import {
  useLocation,
} from 'react-router-dom';

export function useUserByQueryString() {
  const query = new URLSearchParams(useLocation().search);
  const user = query.get('user');

  const userObject = JSON.parse(user);

  return {
    user: userObject,
  };
}
